import React from 'react';
import {Link} from 'react-router-dom';

//Components
import ThemeToggle from './ThemeToggle'
import SpinnerStyleToggle from './SpinnerStyleToggle'
import { useTheme } from '../contexts/ThemeContext';


const Header = () => {
    const { isDarkMode } = useTheme();
    
    // Choose logo based on theme
    const logoSrc = isDarkMode 
        ? '/CloudLabel_logo_darkmode.png' 
        : '/CloudLabel_logo_lightmode.png';
        
    return (
        <div className='bg-white dark:bg-gray-900 pt-0 pl-2 m-0 border-solid border-grafokettblue-1 dark:border-gray-700 flex shadow-lg'>
            <div className='flex items-center justify-between w-full pt-2 pl-0 pr-5 pb-0'>
                <Link to='/'>
                    <img 
                        className='w-32 md:w-48 right-0 ml-4 transition-opacity duration-300' 
                        src={logoSrc} 
                        alt='CloudLabel Logo'
                    />
                </Link>
                <div className='flex items-center space-x-4'>
                    <SpinnerStyleToggle />
                    <ThemeToggle />
                    <Link to='/dashboard'>
                        <button className="flex items-center px-6 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors duration-200 text-sm font-medium shadow-sm hover:shadow-md">
                            <i className="fas fa-chart-line mr-2 text-sm"></i>
                            <span className="hidden sm:block">Dashboard</span>
                        </button>
                    </Link>
                    <Link to='/notifications'>
                        <button className="flex items-center px-6 py-2 bg-grafokett-blue text-white rounded-lg hover:bg-grafokett-blue-dark transition-colors duration-200 text-sm font-medium shadow-sm hover:shadow-md">
                            <i className="fas fa-bell mr-2 text-sm"></i>
                            <span className="hidden sm:block">Notifications</span>
                        </button>
                    </Link>
                    <Link to='organization/new'>
                        <button className="flex items-center px-6 py-2 bg-grafokett-orange text-white rounded-lg hover:bg-orange-600 transition-colors duration-200 text-sm font-medium shadow-sm hover:shadow-md">
                            <i className="fas fa-plus mr-2 text-sm"></i>
                            <span className="hidden sm:block">Add New</span>
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Header;